export default __webpack_public_path__ + "static/media/3967.525af397.png";